export const ASSIGNMENT = 'assignment'
export const EXAM = 'exam'
export const ESSAY = 'essay'
export const BREAK = 'break'
